// Migrated to ES6 class syntax for ol@10 compat.
// - removed inherits() from ol/index.js
// - removed createCanvasContext2D from ol/dom.js (created inline)
import Tile from 'ol/Tile.js';
import TileState from 'ol/TileState.js';

var _seq_id = 1;

/**
 * Helper local pra criar um canvas 2D (substitui ol/dom.createCanvasContext2D
 * que foi removido em ol@7).
 * @param {number} width
 * @param {number} height
 * @returns {CanvasRenderingContext2D}
 */
function createCanvasContext2D(width, height) {
  var canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  return canvas.getContext('2d');
}

/**
 * Tile customizado renderizado em canvas (em vez de img).
 * @extends {Tile}
 */
class CanvasTile extends Tile {
  /**
   * @param {import('ol/tilecoord.js').TileCoord} tileCoord Tile coordinate.
   * @param {import('ol/TileState.js').default} state State.
   * @param {function} tileLoadFunction Tile load function.
   * @param {boolean} waitLoad
   * @param {object=} opt_options Tile options.
   */
  constructor(tileCoord, state, tileLoadFunction, waitLoad, opt_options) {
    super(tileCoord, state, opt_options);

    this._canvas = CanvasTile.createCanvas();
    this._tileLoadFunction = tileLoadFunction;
    this._waitLoad = !!waitLoad;
    this._tileId = _seq_id++;
  }

  disposeInternal() {
    if (this.state === TileState.LOADING) {
      this._canvas = CanvasTile.getBlankCanvas();
    }
    if (this.interimTile) {
      this.interimTile.dispose();
    }

    this.state = TileState.ABORT;
    this.changed();

    super.disposeInternal();
  }

  getTileId() {
    return 'TileCanvas_' + this._tileId;
  }

  getImage() {
    return this._canvas;
  }

  setLoadError() {
    if (this.state !== TileState.LOADING)
      return;

    this.state = TileState.ERROR;
    this._canvas = CanvasTile.getBlankCanvas();
    this.changed();
  }

  setLoadSuccess() {
    if (this.state !== TileState.LOADING)
      return;

    this.state = TileState.LOADED;
    this.changed();
  }

  reset() {
    this.state = TileState.IDLE;
    this._canvas = CanvasTile.createCanvas();
    this.changed();
  }

  load() {
    if (this.state === TileState.ERROR) {
      this.reset();
    }

    if (this.state === TileState.IDLE) {
      var hasLoaded = this._tileLoadFunction(this);

      if (!!hasLoaded) {
        this.state = TileState.LOADED;
        this.changed();
      }
      else if (!this._waitLoad) {
        this.state = TileState.ERROR;
        this._canvas = CanvasTile.getBlankCanvas();
        this.changed();
      }
      else {
        this.state = TileState.LOADING;
        this.changed();

        setTimeout(() => this.setLoadError(), 4000);
      }
    }
  }

  /**
   * Get a 1-pixel blank canvas.
   * @return {HTMLCanvasElement} Blank canvas.
   */
  static getBlankCanvas() {
    var ctx = createCanvasContext2D(1, 1);
    ctx.fillStyle = 'rgba(0,0,0,0)';
    ctx.fillRect(0, 0, 1, 1);
    return ctx.canvas;
  }

  /**
   * Get a empty 256x256 canvas.
   * @return {HTMLCanvasElement} Empty canvas.
   */
  static createCanvas() {
    var ctx = createCanvasContext2D(256, 256);
    return ctx.canvas;
  }
}

export default CanvasTile;
